import React, { Suspense,lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import App from "../App";
import Loader from "../modules/Lobby/Loader";
import Container from 'react-bootstrap/Container';
import SwipeQuickbetXTicket from "../modules/Swipe/container/SwipeQuickbetXTicket";
const SwipeTicket = lazy(() => import('../modules/Swipe/container/SwipeTicket'))
const SwipeQuickbetTicket = lazy(() => import('../modules/Swipe/container/SwipeQuickbetTicket'));
const Jackpot = lazy(() => import('../modules/Jackpot/Container/Jackpot'));
const JackpotOTP = lazy(() => import('../modules/Jackpot/Container/JackpotOTP'));
const JackpotTracking = lazy(() => import('../modules/Jackpot/Container/JackpotTracking'));
const Quickbet = lazy(() => import('../modules/Quickbet/Container/Quickbet'));
const QuickbetOTP = lazy(() => import('../modules/Quickbet/Container/QuickbetOTP'));
const QuickbetTracking = lazy(() => import('../modules/Quickbet/Container/QuickbetTracking'));
const Quicktip = lazy(() => import('../modules/Quicktip/Container/Quicktip'));
const QuicktipOTP = lazy(() => import('../modules/Quicktip/Container/QuicktipOTP'));
const QuicktipRegistred = lazy(() => import('../modules/Quicktip/Container/QuicktipTracking'));
const Smartbet = lazy(() => import('../modules/Smartbet/Container/Smartbet'));
const SmartbetGenerated = lazy(() => import('../modules/Smartbet/Container/SmartbetGenerated'));
const SmartbetTracking = lazy(() => import('../modules/Smartbet/Container/SmartbetTracking'));
const SmartbetOTP = lazy(() => import('../modules/Smartbet/Container/SmartbetOTP'));
const Superbet = lazy(() => import('../modules/Superbet/Containers/Superbet'));
const SuperbetOTP = lazy(() => import('../modules/Superbet/Containers/SuperbetOTP'));
const SuperbetTracking = lazy(() => import('../modules/Superbet/Containers/SuperbetTracking'));
const SwipeQuickbetX = lazy(() => import('../modules/Swipe/container/SwipeQuickbetXTicket'));
const QuickbetX = lazy(() => import('../modules/QuickbetX/Container/QuickbetX'));
const QuickbetXOTP = lazy(() => import('../modules/QuickbetX/Container/QuickbetXOTP'));
const QuickbetXTracking = lazy(() => import('../modules/QuickbetX/Container/QuickbetXTracking'));
const TicketResults = lazy(() => import('../modules/TicketHistory/Containter/TicketHistory'));
const Error404 = lazy(() => import('../modules/Errors/Error404'));
const Siry = lazy(() => import('../modules/TicketHistory/Containter/SiruContainer'));
const ZimplerPage = lazy(() => import('../modules/Zimpler/ZimplerPage'));
const ZimplerConfirmedPage = lazy(() => import('../modules/Zimpler/ZimplerConfirmedPage'));
const ZimplerTrackingPage = lazy(() => import('../modules/Zimpler/ZimplerTrackingPage'));

const PrivateRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={
                <Suspense fallback={<Loader />}>
                    <App />
                </Suspense>
            }>
                <Route index element={<Container>Home Page Content</Container>} />
            </Route>
            <Route path="/jackpot/:id" element={
                <Suspense fallback={<Loader />}>
                    <Jackpot />
                </Suspense>
            } />
            <Route path="/jackpot-list/:id" element={
                <Suspense fallback={<Loader />}>
                    <Jackpot />
                </Suspense>
            } />
            <Route path="/jackpot-swipe/:id" element={
                <Suspense fallback={<Loader />}>
                    <SwipeTicket />
                </Suspense>
            } />
            <Route path="/jackpots/otp" element={
                <JackpotOTP />
            } />
            <Route path="/jackpots/tracking/:id" element={<JackpotTracking />} />
            {/*<Route path="/swipe-demo/:id" element={*/}
            {/*    <Suspense fallback={<Loader />}>*/}
            {/*        <SwipeTicket />*/}
            {/*    </Suspense>*/}
            {/*}*/}
            {/*       />*/}
            <Route path="/quicktip/:id" element={
                <Suspense fallback={<Loader />}>
                    <Quicktip />
                </Suspense>
            } />
            <Route path="/quicktip/otp" element={<QuicktipOTP />} />
            <Route path="/quicktips/tracking/:id" element={<QuicktipRegistred />} />
            <Route path="/quickbetx-swipe/:id" element={
                <Suspense fallback={<Loader />}>
                    <SwipeQuickbetXTicket />
                </Suspense>
            } />
            <Route path="/quickbetx/:id" element={
                <Suspense fallback={<Loader />}>
                    <QuickbetX />
                </Suspense>
            } />
            <Route path="/quickbetx/otp" element={<QuickbetXOTP />} />
            <Route path="/quickbetx/tracking/:id" element={<QuickbetXTracking />} />
            <Route path="/smartbet/:id" element={
                <Suspense fallback={<Loader />}>
                    <Smartbet />
                </Suspense>
            } />
            <Route path="/smartbet/generated" element={<SmartbetGenerated />} />
            <Route path="/smartbet/otp" element={<SmartbetOTP />} />
            <Route path="/smartbet/tracking/:id" element={
                    <SmartbetTracking />
            } />
            <Route path="/superbet/:id" element={
                <Suspense fallback={<Loader />}>
                    <Superbet />
                </Suspense>
            } />
            <Route path="/superbet/otp" element={<SuperbetOTP />} />
            <Route path="/quickbet/:id" element={
                <Suspense fallback={<Loader />}>
                    <Quickbet />
                </Suspense>
            } />
            <Route path="/quickbet-swipe/:id" element={
                <Suspense fallback={<Loader />}>
                    <SwipeQuickbetTicket />
                </Suspense>
            } />
            <Route path="/siru" element={
                <Suspense fallback={<Loader />}>
                    <Siry />
                </Suspense>
            } />
            <Route path="/quickbet/otp" element={<QuickbetOTP />} />
            <Route path="/quickbet/tracking/:id" element={
                <QuickbetTracking />
            } />
            <Route path="/superbet/tracking/:id" element={
                    <SuperbetTracking />
            } />
            <Route path="/track/:ticketCode" element={
                <Suspense fallback={<Loader />}>
                    <TicketResults />
                </Suspense>
            } />
            <Route path="/zimpler" element={
                <Suspense fallback={<Loader />}>
                    <ZimplerPage />
                </Suspense>
            } />
            <Route path="/zimpler-confirmed" element={
                <Suspense fallback={<Loader />}>
                    <ZimplerConfirmedPage />
                </Suspense>
            } />
            <Route path="/zimplerTracking" element={
                <Suspense fallback={<Loader />}>
                    <ZimplerTrackingPage />
                </Suspense>
            } />
            <Route path="*" element={<Error404 />} />
        </Routes>
    );
};

export { PrivateRoutes };
